import { render, staticRenderFns } from "./TyphoonLayer.vue?vue&type=template&id=4512c230"
import script from "./TyphoonLayer.vue?vue&type=script&lang=js"
export * from "./TyphoonLayer.vue?vue&type=script&lang=js"
import style0 from "./TyphoonLayer.vue?vue&type=style&index=0&id=4512c230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports